export default __webpack_public_path__ + "static/media/ill-kyc-verification.8170bc5a.svg";